import { render, staticRenderFns } from "./MerchantProcRules.vue?vue&type=template&id=31917fb0"
import script from "./MerchantProcRules.vue?vue&type=script&lang=js"
export * from "./MerchantProcRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports